import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const NavContainer = styled.ul`
  display: flex;
  flex: 1;
  margin-left: 95px;
  list-style: none;
`;

const Nav = styled.li`
  display: inline-block;
  text-align: center;
  font-size: 24px;
  line-height: 28px;
  width: 150px;
  margin-left: 60px;

  &:last-child {
    margin-right: 0;
  }
`;

const Link = styled.a`
  text-decoration: none;
  transition: color 0.1s, background-color 0.1s;
  color: #fff;
  &::before {
    content: '';
    display: block;
    position: relative;
    bottom: -45px;
    left: 0;
    height: 3px;
    width: 100%;
    background-color: #fff;
    transform-origin: right top;
    transform: scale(0, 1);
    transition: color 0.1s, transform 0.2s ease-out;
  }
  &.active::before {
    background-color: #fff;
    transform-origin: left top;
    transform: scale(1, 1);
  }
  &:hover::before,
  &:focus::before {
    transform-origin: left top;
    transform: scale(1, 1);
  }
`;

const Navbar = ({ clientToken, clubId }) => (
  <NavContainer>
    <Nav>
      <Link href={`#/${clientToken}/clubs/${clubId}/planning`}>Planning</Link>
    </Nav>
    <Nav>
      <Link className="active" href={`#/${clientToken}/clubs/${clubId}/coaches`}>
        Coachs
      </Link>
    </Nav>
  </NavContainer>
);

Navbar.propTypes = {
  clientToken: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Header/Navbar.jsx